import { render, staticRenderFns } from "./SuccessStoryLink.vue?vue&type=template&id=385cd89e"
import script from "./SuccessStoryLink.vue?vue&type=script&lang=js"
export * from "./SuccessStoryLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports